var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"content"},[_c('warnListContent')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }